import { render } from "./donuts.vue?vue&type=template&id=7259c0ab&scoped=true"
import script from "./donuts.vue?vue&type=script&lang=js"
export * from "./donuts.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7259c0ab"

export default script